<template>
    <div>
            <b-row>
                <b-col cols="6">
                    <b-form-group :label="$t('id')">
                        <b-input-group >
                            <div class="label-as-input">{{ isNotNullValue(form.id) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('product_id')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.product_name) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('period_id')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.period_code) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('installment_number')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.installment_number) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group :label="$t('date')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.date) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
    </div>
</template>

<script>
    //Service
    import installmentDatesService from "@/services/installmentDatesService";

    export default {
        data() {
            return {
                formLoading: false,
                form: {
                    code: null,
                    name: null,
                    rank: null
                }
            }
        },
        props: {
            formId: {
                type: Number,
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                installmentDatesService.get(id)
                              .then((response) => {
                                  this.form = response.data.data;
                              })
                              .catch((error) => {
                                  this.showErrors(error)
                              })
            }
        }
    }
</script>
